import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
	selector: 'missing-value',
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div class="mb-3">
			<label
				class="form-label text-muted"
				style="font-size: 0.875rem; margin-bottom: 0.25rem;"
			>
				<strong>{{ props.label }}</strong>
			</label>
			<p>{{ props.textValue }}</p>
		</div>
	`,
})
export class MissingValueType extends FieldType<FieldTypeConfig> {}
